import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PTs from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faLightbulb,
  faNetworkWired,
  faDatabase,
  faGlobe,
} from '@fortawesome/free-solid-svg-icons';

import DefaultBanner from '../../../components/DefaultBanner';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import AspectImage from '../../../components/AspectImage/AspectImage';

import s from './AppDev.scss';

class AppDev extends React.Component {
  static propTypes = {
    location: PTs.string,
  };

  static defaultProps = {
    location: null,
  };

  render() {
    const { location } = this.props;

    return (
      <div>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <a
                  href="https://fluxtech.co/"
                  itemProp="item"
                  itemType="https://schema.org/ListItem"
                >
                  <span itemProp="name">Home</span>
                </a>
                <meta content="0" itemProp="position" />
              </li>
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <a
                  href="https://fluxtech.co/solutions/"
                  itemProp="item"
                  itemType="https://schema.org/ListItem"
                >
                  <span itemProp="name">Solutions</span>
                  <meta content="1" itemProp="position" />
                </a>
              </li>
              <li>App Development</li>
            </ul>
          }
          header={
            location ? `App Development in ${location}` : 'App Development'
          }
          subHeader="We build robust web and mobile apps from planning to production."
        />

        <section className={s.main}>
          <Grid>
            <Row>
              <Col md={6}>
                <div className={s.image}>
                  <AspectImage
                    altText="A web application on a laptop"
                    aspectRatio="16:9"
                    src="/images/min/web-application.jpg"
                    width="100%"
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className={s.webApplications}>
                  <h2>Web Applications</h2>
                  <p>
                    We focus on building fully-fledged web applications that can
                    be viewed on any device. With years of experience using web
                    technologies you can trust us to build just about anything.
                  </p>
                </div>
              </Col>
              <Col md={6}>
                <div className={s.mobileApplications}>
                  <h2>Mobile Applications</h2>
                  <p>
                    We write software for both iOS and Android for a time when
                    it makes sense to develop a mobile solution.
                  </p>
                </div>
              </Col>
              <Col md={6}>
                <div className={s.image}>
                  <AspectImage
                    altText="Person using a mobile phone"
                    aspectRatio="16:9"
                    src="/images/min/mobile-application.jpg"
                    width="100%"
                  />
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
        <section className={s.planningToProduction}>
          <Grid>
            <Row>
              <Col lg={12}>
                <h2>From Planning to Production</h2>
                <p>
                  We help businesses bring web or mobile apps from idea to
                  production in a series of four steps. Every step along the
                  way, we'll be here to help make your app the success it needs
                  to be.
                </p>
              </Col>
              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon className={s.faIcon} icon={faLightbulb} />
                  </div>
                  <div className={s.content}>
                    <h3>Idea</h3>
                    <p>
                      Here we help take you from idea to business model.
                      Consulting you on what works and what doesn't.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon
                      className={s.faIcon}
                      icon={faNetworkWired}
                    />
                  </div>
                  <div className={s.content}>
                    <h3>Wireframe & Mockup</h3>
                    <p>
                      Wireframes and mockups are used to thoroughly plan the app
                      out. We need to understand exactly what it is going to
                      take to build.
                    </p>
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon className={s.faIcon} icon={faDatabase} />
                  </div>
                  <div className={s.content}>
                    <h3>Development</h3>
                    <p>
                      Here is the part of the process where software is written.
                      We typically follow the Agile methodology to get products
                      to market faster.
                    </p>
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className={s.info}>
                  <div className={s.circleContainer}>
                    <FontAwesomeIcon className={s.faIcon} icon={faGlobe} />
                  </div>
                  <div className={s.content}>
                    <h3>Production</h3>
                    <p>
                      Your product is now online for the world to see. Here we
                      can get feedback on what is working and what isn't.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
      </div>
    );
  }
}

export default withStyles(s)(AppDev);
